import AGREEMENT from '../agreement';
import LANGUAGES from '../languages';

export default {
	APP_TITLE: 'HollaEx',
	APP_SUB_TITLE: 'Open Crypto Exchange', // slogan

	LOGOUT_CONFIRM_TEXT: 'Quý khách có chắc chắn muốn đăng xuất không?',
	ADD_TRADING_PAIR: 'Thêm cặp giao dịch',
	ACTIVE_TRADES: 'Quý khách cần {0} để thực hiện giao dịch thực tế',
	CANCEL_BASE_WITHDRAWAL: 'Hủy yêu cầu rút {0}',
	CANCEL_WITHDRAWAL: 'Hủy yêu cầu rút tiền',
	CANCEL_WITHDRAWAL_POPUP_CONFIRM:
		'Quý khách có chắc chắn muốn hủy yêu cầu rút tiền đang được thực hiện hay không?:',
	CANT_BE_CANCELLED: '-',
	ALREADY_CANCELLED: '-',
	TIMESTAMP_FORMAT: 'YYYY/MM/DD HH:mm:ss',
	HOUR_FORMAT: 'HH:mm:ss',
	LOGIN_TEXT: 'Đăng nhập',
	SIGN_IN: 'Đăng nhập',
	SIGNUP_TEXT: 'Đăng ký',
	REGISTER_TEXT: 'Đăng ký',
	ACCOUNT_TEXT: 'Tài khoản',
	HOME_TEXT: 'Home',
	CLOSE_TEXT: 'Đóng',
	COPY_TEXT: 'Sao chép',
	COPY_SUCCESS_TEXT: 'Sao chép thành công',
	CANCEL_SUCCESS_TEXT: 'Đã hủy thành công!',
	UPLOAD_TEXT: 'Tải lên',
	ADD_FILES: 'THÊM TẬP TIN', // ToDo
	OR_TEXT: 'Hoặc',
	CONTACT_US_TEXT: 'Liên hệ',
	HELPFUL_RESOURCES_TEXT: 'Các nguồn hỗ trợ',
	HELP_RESOURCE_GUIDE_TEXT:
		'Hãy liên hệ tới địa chỉ email của chúng tôi nếu quý khách có bất kỳ thắc mắc hay vấn đề nào.',
	HELP_RESOURCE_GUIDE: {
		CONTACT_US: 'liên hệ với chúng tôi',
		TEXT:
			'Vui lòng {0} bằng cách gửi email nếu quý khách có thắc mắc hay gặp phải bất kỳ vấn đề nào',
	},
	HELP_TELEGRAM_TEXT: 'Xác nhận tài liệu ứng dụng mở (open API):',
	HELP_TELEGRAM_LINK: 'https://apidocs.hollaex.com',
	NEED_HELP_TEXT: 'Quý khách cần giúp đỡ?', // new
	HELP_TEXT: 'Hỗ trợ',
	SUCCESS_TEXT: 'Thành công',
	ERROR_TEXT: 'Lỗi',
	PROCEED: 'THỰC HIỆN',
	EDIT_TEXT: 'Chỉnh sửa',
	BACK_TEXT: 'Quay lại',
	NO_OPTIONS: 'Không có lựa chọn nào khả dụng',
	SECONDS: 'seconds',
	VIEW_MARKET: 'Xem thị trường', // new
	GO_TRADE: 'Giao dịch', // new
	VIEW_INFO: 'Xem trang thông tin', // new
	APPLY_HERE: 'Apply Here', // new
	HOME: {
		SECTION_1_TITLE: 'Chào mừng quý khách đến với HollaEx Exchange Kit!',
		SECTION_1_TEXT_1:
			'Hãy xây dựng sàn giao dịch tiền điện tử có khả năng mở rộng cùng với HollaEx Kit và trở thành một phần tương lai của lĩnh vực tài chính.',
		SECTION_1_TEXT_2:
			'Chúng tôi nỗ lực để thúc đẩy công nghệ tài chính phát triển thông qua công nghệ giao dịch thông minh và dễ tiếp cận.',
		SECTION_1_BUTTON_1: 'Tìm hiểu thêm',
		SECTION_3_TITLE: 'Tính năng',
		SECTION_3_CARD_1_TITLE: 'CÔNG CỤ GHÉP NỐI CÓ KHẢ NĂNG MỞ RỘNG',
		SECTION_3_CARD_1_TEXT:
			'Sử dụng thuật toán hiệu quả nhất để tạo ra công cụ ghép nối có khả năng mở rộng tốt nhất.',
		SECTION_3_CARD_2_TITLE: 'KẾT HỢP NGÂN HÀNG',
		SECTION_3_CARD_2_TEXT:
			'Có thể kết hợp với ngân hàng tùy theo nhu cầu và đặc điểm của khách hàng. Chúng tôi hiểu rõ về nền tài chính truyền thống và có thể hỗ trợ quý khách tạo ra sàn giao dịch bản địa.',
		SECTION_3_CARD_3_TITLE: 'BẢO MẬT TỐI ƯU',
		SECTION_3_CARD_3_TEXT:
			'HollaEx sử dụng những biện pháp bảo mật tốt nhất cùng với các thuật toán an toàn và đáng tin cậy nhất để bảo vệ tài sản. Đây là ưu tiên hàng đầu của chúng tôi và chúng tôi đặc biệt chú ý tới khía cạnh này.',
		SECTION_3_CARD_4_TITLE: 'TÍNH NĂNG BÁO CÁO NÂNG CAO',
		SECTION_3_CARD_4_TEXT:
			'Thông qua bảng điều khiển, chúng tôi cung cấp thông báo và email về tình trạng của hệ thống cũng như giao dịch cho đội hỗ trợ và người quản lý.',
		SECTION_3_CARD_5_TITLE: 'HỖ TRỢ',
		SECTION_3_CARD_5_TEXT:
			'Chúng tôi đáp ứng nhu cầu của khách hàng với sự hỗ trợ tận tình nhất và có một đội ngũ tư vấn trực tuyến chuyên nghiệp để hỗ trợ xử lý các vấn đề và yêu cầu.',
		SECTION_3_CARD_6_TITLE: 'LIÊN KẾT KYC',
		SECTION_3_CARD_6_TEXT:
			'Chúng tôi mang tới một bộ máy linh hoạt, có khả năng mở rộng để có thể áp dụng KYC và các phương thức xác thực người dùng ở các phạm vi liên quan khác.',
		SECTION_3_BUTTON_1: 'Xem Demo',
	},
	FOOTER: {
		FOOTER_LEGAL: ['Proudly made in Seoul, South Korea', 'bitHolla Inc.'],
		FOOTER_LANGUAGE_TEXT: 'LANGUAGE',
		SECTIONS: {
			SECTION_1_TITLE: 'ABOUT',
			SECTION_1_LINK_1: 'About Us',
			SECTION_1_LINK_2: 'Điều khoản sử dụng',
			SECTION_1_LINK_3: 'Chính sách bảo mật',
			SECTION_1_LINK_4: 'Contact Us',
			SECTION_2_TITLE: 'Information',
			SECTION_2_LINK_1: 'Blog',
			SECTION_2_LINK_2: 'Contact Us',
			SECTION_2_LINK_3: 'Career',
			SECTION_3_TITLE: 'DEVELOPERS',
			SECTION_3_LINK_1: 'Documentation',
			SECTION_3_LINK_2: 'Forum',
			SECTION_3_LINK_3: 'GitHub',
			SECTION_3_LINK_4: 'Library',
			SECTION_3_LINK_5: 'Tài liệu API',
			SECTION_3_LINK_6: 'Trading API',
			SECTION_3_LINK_7: 'Developer tools',
			SECTION_3_LINK_8: 'Documnetation',
			SECTION_4_TITLE: 'EXCHANGE',
			SECTION_4_LINK_1: 'Đăng nhập',
			SECTION_4_LINK_2: 'Đăng ký',
			SECTION_4_LINK_3: 'Contact Us',
			SECTION_4_LINK_4: 'Terms of Use',
			SECTION_5_TITLE: 'RESOURCES',
			SECTION_5_LINK_1: 'Whitepaper',
			SECTION_5_LINK_2: 'HollaEx Token (XHT) ',
			SECTION_5_LINK_3: 'GitHub',
			SECTION_5_LINK_4: 'FAQ', // new
			SECTION_6_TITLE: 'SOCIAL',
			SECTION_6_LINK_1: 'Twitter',
			SECTION_6_LINK_2: 'Telegram',
			SECTION_6_LINK_3: 'Facebook', // new
			SECTION_6_LINK_4: 'Instagram', // new
			SECTION_6_LINK_5: 'Linkedin', // new
			SECTION_6_LINK_6: 'Website', // new
			SECTION_6_LINK_7: 'Helpdesk', // new
			SECTION_6_LINK_8: 'Information', // new
			SECTION_6_LINK_9: 'YouTube', // new
		},
		XHT_DESCRIPTION:
			'HollaEx Kit là một nền tảng giao dịch mã nguồn mở được xây dựng bởi bitHolla Inc. Quý khách có thể tạo ra và niêm yết bất kỳ tài sản điện tử nào và hỗ trợ người dùng giao dịch trên sàn giao dịch của mình bằng cách sử dụng Kit sàn giao dịch. Cài đặt một bản cho riêng mình {1}.',
		CLICK_HERE: 'Nhấn vào đây',
		VISIT_HERE: 'Chuyển tới đây',
	},
	ACCOUNTS: {
		TITLE: 'Tài khoản',
		TAB_VERIFICATION: 'Xác thực',
		TAB_SECURITY: 'Bảo mật',
		TAB_NOTIFICATIONS: 'Thông báo',
		TAB_SETTINGS: 'Cài đặt',
		TAB_PROFILE: 'Thông tin cá nhân',
		TAB_WALLET: 'Ví',
		TAB_SUMMARY: 'Khái quát',
		TAB_HISTORY: 'Lịch sử',
		TAB_API: 'API',
		TAB_SIGNOUT: 'Đăng xuất',
	},
	REQUEST_XHT_ACCESS: {
		// new
		REQUEST_TITLE: 'Yêu cầu truy cập',
		REQUEST_INVITE: 'Yêu cầu mời tham gia',
		CATEGORY_PLACEHOLDER: 'Chọn hạng mục phù hợp nhất với vấn đề của quý khách',
		INTRODUCTION_LABEL: 'Giới thiệu bản thân',
		INTRODUCTION_PLACEHOLDER:
			'Nền tảng của quý khách ở đâu? Quý khách hứng thú với việc vận hành sàn giao dịch?',
	},
	CONTACT_FORM: {
		CATEGORY_LABEL: 'Hạng mục',
		CATEGORY_PLACEHOLDER: 'Chọn hạng mục phù hợp nhất với vấn đề của quý khách',
		CATEGORY_OPTIONS: {
			OPTION_VERIFY: 'Xác thực người dùng',
			OPTION_LEVEL: 'Tăng cấp bậc',
			OPTION_DEPOSIT: 'Nạp tiền & Rút tiền',
			OPTION_BUG: 'Báo cáo lỗi', // ToDo:
			OPTION_PERSONAL_INFO: 'Thay đổi thông tin cá nhân', // ToDo:
			OPTION_BANK_TRANSFER: 'Chuyển khoản điện tử liên ngân hàng', // new
			OPTION_REQUEST: 'Yêu cầu mời tham gia HollaEx Exchange', // new
		},
		SUBJECT_LABEL: 'Tiêu đề',
		SUBJECT_PLACEHOLDER: 'Nhập tiêu đề cho vấn đề của quý khách',
		DESCRIPTION_LABEL: 'Nội dung',
		DESCRIPTION_PLACEHOLDER: 'Nhập nội dung chi tiết vấn đề của bạn',
		ATTACHMENT_LABEL: 'Tệp tin đính kèm(Tối đa 3 tập tin)', // ToDo:
		ATTACHMENT_PLACEHOLDER:
			'Thêm tập tin để tạo thuận lợi cho công tác hỗ trợ. Tập dịnh có định dạng PDF, JPG, PNG và GIF được chấp nhận.',
		SUCCESS_MESSAGE: 'Email đã được chuyển tới đội hỗ trợ của chúng tôi.',
		SUCCESS_TITLE: 'Đã gửi',
		SUCCESS_MESSAGE_1:
			'Vấn đề của quý khách đã được gửi tới đội hỗ trợ khách hàng.',
		SUCCESS_MESSAGE_2: 'Thủ tục hồi đáp có thể mất 1-3 ngày làm việc.',
	},
	DEPOSIT: {
		CRYPTO_LABELS: {
			ADDRESS: 'Địa chỉ nhận {0}', // new
			DESTINATION_TAG: 'Thẻ tên đích đến của {0}', // new
			MEMO: 'Chú thích {0}', // new
			BTC: 'Địa chỉ nhận Bitcoin',
			ETH: 'Địa chỉ nhận Ethereum',
			BCH: 'Địa chỉ nhận Bitcoin Cash',
		},
		INCREASE_LIMIT: 'Quý khách muốn nâng hạn mức mỗi ngày của mình?',
		QR_CODE: 'Người muốn chuyển tiền cho quý khách có thể quét mã QR này.',
		NO_DATA: 'Không có thông tin phù hợp',
		FULL_MESSAGE_LIMIT: '{0}: {1} {2} {3}', //  0 -> {Daily deposit max amount}:  1 -> {50,000,000} 2 -> {T} 3 -> {(Want to increase your daily limit?)}
	},
	LOGIN: {
		LOGIN_TO: 'Đăng nhập {0}',
		CANT_LOGIN: 'Quý khách không thể đăng nhập?',
		NO_ACCOUNT: 'Quý khách không có tài khoản?',
		CREATE_ACCOUNT: 'Tạo tài khoản tại đây',
		HELP: 'Help',
	},
	FORM_FIELDS: {
		EMAIL_LABEL: 'Email',
		EMAIL_PLACEHOLDER: 'Vui lòng nhập địa chỉ email',
		PASSWORD_LABEL: 'Mật khẩu',
		PASSWORD_PLACEHOLDER: 'Vui lòng nhập mật khẩu',
		PASSWORD_REPEAT_LABEL: 'Vui lòng nhập lại mật khẩu',
		PASSWORD_REPEAT_PLACEHOLDER: 'Vui lòng nhập lại mật khẩu',
	},
	VALIDATIONS: {
		OTP_LOGIN: 'Nhập mã OTP để đăng nhập',
		CAPTCHA: 'Expired Session. Please refresh the page',
		FROZEN_ACCOUNT: 'This account is frozen',
		INVALID_EMAIL: 'Địa chỉ email không hợp lệ',
		TYPE_EMAIL: 'Vui lòng nhập địa chỉ email',
		REQUIRED: 'Hạng mục bắt buộc',
		INVALID_DATE: 'Ngày không hợp lệ',
		INVALID_PASSWORD:
			'Mật khẩu không hợp lệ. Mật khẩu cần bao gồm ít nhất 8 kts tự, 1 chữ số và 1 ký tự đặc biệt.',
		INVALID_PASSWORD_2:
			'Mật khẩu không hợp lệ. Mật khẩu cần bao gồm ít nhất 8 kts tự, ít nhất 1 chữ số và ít nhất 1 ký tự đặc biệt.',
		INVALID_CURRENCY: 'Địa chỉ {0} không hợp lệ ({1})',
		INVALID_BALANCE: 'Không đủ số dư ({0}) để thực hiện thủ tục ({1}).',
		MIN_VALUE: 'Giá trị phải bằng {0} hoặc cao hơn.',
		MAX_VALUE: 'Giá trị phải bằng {0} hoặc thấp hơn.',
		INSUFFICIENT_BALANCE: 'Số dư không đủ',
		PASSWORDS_DONT_MATCH: 'Mật khẩu không chính xác',
		USER_EXIST: 'Đại chỉ email đã được sử dụng',
		ACCEPT_TERMS:
			'Quý khách chưa đồng ý Điều khoản sử dụng và chính sách bảo mật',
		STEP: 'Giá trị không hợp lệ, step is {0}',
		ONLY_NUMBERS: 'Chỉ có thể nhập chữ số',
		MIN_VALUE_NE: 'Giá phải cao hơn {0}.', //new
	},
	LEGAL: {
		PRIVACY_POLICY: {
			TITLE: 'Privacy Policy',
			SUBTITLE:
				'Last updated April 1, 2019. Replaces the prior version in its entirety.',
			TEXTS: [
				'HollaEx Web is a virtual trading platform that is wholly owned by bitHolla Inc. bitHolla Inc (hereinafter referred to as bitHolla) was incorporated in Seoul South Korea.',
				'Use of this HollaEx website (“Website”) and the service offered on the Website (“Service”) are governed by the terms contained on this Terms and Conditions page (“Terms”). This agreement entirely constitutes the agreement between the parties. All other information provided on the Website or oral/written statements made are excluded from this agreement; the exchange policy is provided for guidance only and does not constitute a legal agreement between the parties.',
				'By accessing, viewing or downloading information from the Website and using the Service provided by bitHolla you acknowledge that you have read, understand, and unconditionally agree to be bound by these Terms. bitHolla may at any time, without notice, amend the Terms. You agree to continue to be bound by any amended terms and conditions and that bitHolla has no obligation to notify you of such amendments. You acknowledge that it is your responsibility to check these Terms periodically for changes and that your continued use of the Website and Services offered by bitHolla following the posting of any changes to the Terms indicates your acceptance of any such changes.',
				'The Website and the copyright in all text, graphics, images, software and any other materials on the Website is owned by bitHolla including all trademarks and other intellectual property rights in respect of materials and Service on the Website. Materials on this Website may only be used for personal use and non-commercial purposes.',
				'You may display on a computer screen or print extracts from the Website for the above-stated purpose only provided that you retain any copyright and other proprietary notices or any bitHolla trademarks or logos, as shown on the initial printout or download without alteration, addition or deletion. Except as expressly stated herein, you may not without bitHolla’s prior written permission alter, modify, reproduce, distribute or use in any other commercial context any materials from the Website.',
				'You acknowledge that ‘bitHolla’ and the bitHolla logo are trademarks of bitHolla Inc. You may reproduce such trademarks without alteration on material downloaded from this Website to the extent authorised above, but you may not otherwise use, copy, adapt or erase them.',
				'You shall not in any circumstances obtain any rights over or in respect of the Website (other than rights to use the Website pursuant to these Terms and any other terms and conditions governing a particular service or section of the Website) or hold yourself out as having any such rights over or in respect of the Website.',
			],
		},
		GENERAL_TERMS: {
			TITLE: 'General Terms of Service',
			SUBTITLE:
				'Last updated April 1, 2019. Replaces the prior version in its entirety.',
			TEXTS: [
				'HollaEx Web is a virtual trading platform that is wholly owned by bitHolla Inc. bitHolla Inc (hereinafter referred to as bitHolla) was incorporated in Seoul South Korea.',
				'Use of this HollaEx website (“Website”) and the service offered on the Website (“Service”) are governed by the terms contained on this Terms and Conditions page (“Terms”). This agreement entirely constitutes the agreement between the parties. All other information provided on the Website or oral/written statements made are excluded from this agreement; the exchange policy is provided for guidance only and does not constitute a legal agreement between the parties.',
				'By accessing, viewing or downloading information from the Website and using the Service provided by bitHolla you acknowledge that you have read, understand, and unconditionally agree to be bound by these Terms. bitHolla may at any time, without notice, amend the Terms. You agree to continue to be bound by any amended terms and conditions and that bitHolla has no obligation to notify you of such amendments. You acknowledge that it is your responsibility to check these Terms periodically for changes and that your continued use of the Website and Services offered by bitHolla following the posting of any changes to the Terms indicates your acceptance of any such changes.',
				'The Website and the copyright in all text, graphics, images, software and any other materials on the Website is owned by bitHolla including all trademarks and other intellectual property rights in respect of materials and Service on the Website. Materials on this Website may only be used for personal use and non-commercial purposes.',
				'You may display on a computer screen or print extracts from the Website for the above-stated purpose only provided that you retain any copyright and other proprietary notices or any bitHolla trademarks or logos, as shown on the initial printout or download without alteration, addition or deletion. Except as expressly stated herein, you may not without bitHolla’s prior written permission alter, modify, reproduce, distribute or use in any other commercial context any materials from the Website.',
				'You acknowledge that ‘bitHolla’ and the bitHolla logo are trademarks of bitHolla Inc. You may reproduce such trademarks without alteration on material downloaded from this Website to the extent authorised above, but you may not otherwise use, copy, adapt or erase them.',
				'You shall not in any circumstances obtain any rights over or in respect of the Website (other than rights to use the Website pursuant to these Terms and any other terms and conditions governing a particular service or section of the Website) or hold yourself out as having any such rights over or in respect of the Website.',
			],
		},
	},
	NOTIFICATIONS: {
		BUTTONS: {
			OKAY: 'Okay',
			START_TRADING: 'Bắt đầu giao dịch',
			SEE_HISTORY: 'Xem lịch sử',
		},
		DEPOSITS: {
			TITLE_RECEIVED: 'Đã nhận {0} thành công',
			TITLE_INCOMING: 'Thủ tục nhận {0} đang được xử lý',
			SUBTITLE_RECEIVED: 'Quý khách đã nhận {0} thành công',
			SUBTITLE_INCOMING: 'Thủ tục nhận {0} của quý khách đang được xử lý',
			INFORMATION_PENDING_1:
				'{0} đòi hỏi ít nhất 1 lệnh chấp thuận trước khi có thể giao dịch.',
			INFORMATION_PENDING_2:
				'Thủ tục này có thể mất 10-30 phút. Chúng tôi sẽ gửi email thông báo khi {0} được chấp thuận trên blockchain.',
		},
	},
	REFERRAL_SUCCESS: {
		TITLE: 'Đã gửi yêu cầu',
		BUTTON_TEXT: 'Okay',
	},
	OTP_FORM: {
		OTP_FORM_TITLE: 'Vui lòng nhập mã xác nhận để tiếp tục',
		OTP_LABEL: 'Mã OTP',
		OTP_PLACEHOLDER: 'Vui lòng nhập mã xác nhận',
		OTP_TITLE: 'Mã xác nhận',
		OTP_HELP: 'Hỗ trợ',
		OTP_BUTTON: 'Gửi',
		ERROR_INVALID: 'Mã OTP không hợp lệ',
	},
	QUICK_TRADE_COMPONENT: {
		TITLE: 'Giao dịch nhanh',
		TOTAL_COST: 'Tổng chi phí',
		BUTTON: 'KIỂM TRA LỆNH ĐẶT HÀNG',
		INPUT: 'Số lượng {0} muốn {1}',
		TRADE_TITLE: '{1} {0}', // quick buy
	},
	PREVIOUS_PAGE: 'Trang trước',
	NEXT_PAGE: 'Trang tiếp theo',
	WALLET: {
		LOADING_ASSETS: 'Loading assets...', // new
		TOTAL_ASSETS: 'Tổng tài sản',
		AVAILABLE_WITHDRAWAL: 'Tài sản có thể giao dịch',
		AVAILABLE_TRADING: 'Tài sản có thể rút',
		ORDERS_PLURAL: 'Đặt hàng',
		ORDERS_SINGULAR: 'Đặt hàng',
		HOLD_ORDERS:
			'You have {0} open {1}, resulting in a hold of {2} {3} placed on your {4} balance',
	},
	REQUEST_RESET_PASSWORD: {
		TITLE: 'Khôi phục tài khoản',
		SUBTITLE: `Khôi phục tài khoản phía dưới của quý khách`,
		SUPPORT: 'Liên hệ đội hỗ trợ',
		BUTTON: 'Gửi liên kết khôi phục',
	},
	REQUEST_RESET_PASSWORD_SUCCESS: {
		TITLE: 'Đã gửi yêu cầu đặt lại mật khẩu.',
		TEXT:
			'Nếu địa chỉ email này được sử dụng để đăng ký một tài khoản thì chúng tôi đã gửi thư tới địa chỉ này kèm theo hướng dẫn đặt lại. Vui lòng kiểm tra hòm thư của quý khách và nhấn vào liên kết để hoàn tất thủ tục đặt lại mật khẩu.',
	},
	RESET_PASSWORD: {
		TITLE: 'Đặt mật khẩu mới',
		SUBTITLE: 'Đặt mật khẩu mới',
		BUTTON: 'Đặt mật khẩu mới',
	},
	RESET_PASSWORD_SUCCESS: {
		TEXT_1: 'Mật khẩu mới đã được thiết lập thành công.',
		TEXT_2: 'Nhấn vào nút đăng nhập phía dưới để tiếp tục.',
	},
	SIGN_UP: {
		SIGNUP_TO: 'Đăng ký vào {0}',
		NO_EMAIL: 'Quý khách không nhận được email?',
		REQUEST_EMAIL: 'Yêu cầu gửi một email khác',
		HAVE_ACCOUNT: 'Quý khách đã có tài khoản?',
		GOTO_LOGIN: 'Chuyển tới trang đăng nhập',
		AFFILIATION_CODE: 'Mã giới thiệu (không bắt buộc)',
		AFFILIATION_CODE_PLACEHOLDER: 'Vui lòng nhập mã giới thiệu',
		TERMS: {
			terms: 'Điều khoản chung',
			policy: 'Chính sách bảo mật',
			text: 'Tôi đã đọc và đồng ý với {0} và {1}',
		},
	},
	VERIFICATION_TEXTS: {
		TITLE: 'Đã gửi email xác nhận.',
		TEXT_1:
			'Kiểm tra hòm thư của quý khách và nhấn vào liên kết để xác nhận địa chỉ email.',
		TEXT_2:
			'Nếu không nhận được email, hãy kiểm tra hòm thư rác hoặc yêu cầu nhận một email xác nhận mới.',
	},
	VERIFICATION_EMAIL_REQUEST: {
		TITLE: 'Gửi lại email xác nhận',
		BUTTON: 'Yêu cầu gửi email',
	},
	VERIFICATION_EMAIL_REQUEST_SUCCESS: {
		TITLE: 'Đã gửi lại email xác nhận.',
		TEXT_1:
			'Trong trường hợp không nhận được email sau vài phút nữa, vui lòng liên hệ với chúng tôi theo địa chỉ bên dưới.',
	},
	VERIFICATION_EMAIL: {
		INVALID_UUID: 'Mã không hợp lệ',
		TEXT_1: 'Quý khách đã xác nhận địa chi email thành công.',
		TEXT_2: 'Giờ đây, quý khách có thể thể đăng nhập vào tài khoản.',
	},
	USER_VERIFICATION: {
		INFO_TXT:
			'Quý khách có thể xác nhận trình tự xác thực và nâng cấp tài khoản tại đây.',
		INFO_TXT_1:
			'Vui lòng nhập các thông tin cần thiết cho mỗi hạng mục phía dưới. Các thông tin của quý khách chỉ được xem xét và chấp nhận khi tất cả các hạng mục được nhập đầy đủ.',
		INFO_TXT_2:
			'* Thủ tục xác thực người dùng đòi hỏi bắt buộc các hồ sơ về {0}.',
		DOCUMENTATIONS: 'Tải lên',
		COMPLETED: 'Hoàn tất',
		PENDING_VERIFICATION: 'Đang chờ xác thực',
		TITLE_EMAIL: 'Email',
		MY_EMAIL: 'Email của tôi',
		MAKE_FIRST_DEPOSIT: 'Thực hiện yêu cầu nạp tiền đầu tiên', // new
		OBTAIN_XHT: 'Nhận XHT', // new
		TITLE_USER_DOCUMENTATION: 'Identification',
		TITLE_ID_DOCUMENTS: 'Tải lên',
		TITLE_BANK_ACCOUNT: 'Tài khoản ngân hàng',
		TITLE_MOBILE_PHONE: 'Số điện thoại',
		TITLE_PERSONAL_INFORMATION: 'Thông tin cá nhân',
		VERIFY_EMAIL: 'Xác thực địa chỉ email',
		VERIFY_MOBILE_PHONE: 'Xác thực số điện thoại',
		VERIFY_USER_DOCUMENTATION: 'Xác thực hồ sơ của người dùng',
		VERIFY_ID_DOCUMENTS: 'Xác thực giấy tờ tùy thân  ',
		VERIFY_BANK_ACCOUNT: 'Xác thực tài khoản ngân hàng',
		BUTTON: 'Gửi yêu cầu xác thực',
		TITLE_IDENTITY: 'Thông tin cá nhân',
		TITLE_MOBILE: 'Điện thoại',
		TITLE_MOBILE_HEADER: 'Số điện thoại',
		TITLE_BANK: 'Ngân hàng',
		TITLE_BANK_HEADER: 'Chi tiết ngân hàng',
		CHANGE_VALUE: 'Thay đổi',
		PENDING_VERIFICATION_PERSONAL_INFORMATION:
			'Các thông tin cá nhân của quý khách đang được xử lý',
		PENDING_VERIFICATION_BANK:
			'THông tin chi tiết về ngân hàng của quý khách đã được xác thực.',
		PENDING_VERIFICATION_DOCUMENTS: 'Tài liệu của quý khách đã được xác thực',
		GOTO_VERIFICATION: 'Chuyển đến trang Xác thực',
		GOTO_WALLET: 'Chuyển đến Ví', // new
		CONNECT_BANK_ACCOUNT: 'Liên kết tài khoản ngân hàng',
		ACTIVATE_2FA: 'Kích hoạt 2FA',
		INCOMPLETED: 'Chưa hoàn tất',
		BANK_VERIFICATION: 'Xác thực ngân hàng',
		IDENTITY_VERIFICATION: 'Xác thực người dùng',
		PHONE_VERIFICATION: 'Xác thực số điện thoại',
		DOCUMENT_VERIFICATION: 'Xác thực tài liệu',
		START_BANK_VERIFICATION: 'Bắt đầu xác thực ngân hàng',
		START_IDENTITY_VERIFICATION: 'Bắt đầu xác thực người dùng',
		START_PHONE_VERIFICATION: 'Bắt đầu xác thực số điện thoại',
		START_DOCUMENTATION_SUBMISSION: 'Bắt đầu gửi hồ sơ',
		GO_BACK: 'Quay lại',
		BANK_VERIFICATION_TEXT_1:
			'Quý khách có thể thêm 3 tài khoản ngân hàng. Để thêm tài khoản ngân hàng quốc tế, quý khách cần liên hệ với đội hỗ trợ và sẽ bị giới hạn mức rút tiền.',
		BANK_VERIFICATION_TEXT_2:
			'Sau khi xác thực tài khoản ngân hàng, quý khách có thể sử dụng các dịch vụ sau:',
		BASE_WITHDRAWAL: 'Rút tiền mặt',
		BASE_DEPOSITS: 'Nạp tiền mặt',
		ADD_ANOTHER_BANK_ACCOUNT: 'Thêm tài khoản ngân hàng',
		BANK_NAME: 'Tên ngân hàng',
		ACCOUNT_NUMBER: 'Số tài khoản',
		CARD_NUMBER: 'Số thẻ',
		BANK_VERIFICATION_HELP_TEXT:
			'Cần hoàn tất hạng mục {0} trước khi có thể xác thực mục này.',
		DOCUMENT_SUBMISSION: 'Gửi hồ sơ',
		REVIEW_IDENTITY_VERIFICATION: 'Kiểm tra xác thực người dùng',
		PHONE_DETAILS: 'Chi tiết số điện thoại',
		PHONE_COUNTRY_ORIGIN: 'Quốc gia hòa mạng',
		MOBILE_NUMBER: 'Số điện thoại',
		DOCUMENT_PROOF_SUBMISSION: 'Gửi hồ sơ',
		START_DOCUMENTATION_RESUBMISSION: 'Gửi lại hồ sơ',
		SUBMISSION_PENDING_TXT:
			'*Hồ sơ của hạng mục này đã được gửi. Nếu thay đổi và gửi lại, hồ sơ mới sẽ thay thế hồ sơ cũ được gửi đi trước đó.',
		CUSTOMER_SUPPORT_MESSAGE: 'Tin nhắn của đội hỗ trợ khách hàng',
		DOCUMENT_PENDING_NOTE:
			'Hồ sơ của quý khách đã được gửi và đang chờ xử lý. Vui lòng kiên nhẫn chờ đợi.',
		DOCUMENT_VERIFIED_NOTE: 'Hồ sơ của bạn đã hoàn tất.',
		NOTE_FROM_VERIFICATION_DEPARTMENT: 'Lưu ý từ bộ phận đánh giá hồ sơ',
		CODE_EXPIRES_IN: 'Mã hết hạn',
		USER_DOCUMENTATION_FORM: {
			FORM_FIELDS: {
				FIRST_NAME_LABEL: 'Tên',
				FIRST_NAME_PLACEHOLDER:
					'Vui lòng nhập tên trùng khớp với giấy tờ tùy thân của quý khách.',
				LAST_NAME_LABEL: 'Họ',
				LAST_NAME_PLACEHOLDER:
					'Vui lòng nhập họ trùng khớp với giấy tờ tùy thân của quý khách',
				FULL_NAME_LABEL: 'Tên đầy đủ',
				FULL_NAME_PLACEHOLDER:
					'Vui lòng nhập tên đầy đủ trùng khớp với giấy tờ tùy thân của quý khácht',
				GENDER_LABEL: 'Giới tính',
				GENDER_PLACEHOLDER: 'Vui lòng nhập giới tính của quý khách',
				GENDER_OPTIONS: {
					MAN: 'Nam',
					WOMAN: 'Nữ',
				},
				NATIONALITY_LABEL: 'Quốc tịch',
				NATIONALITY_PLACEHOLDER:
					'Vui lòng nhập thông tin trùng khớp với giấy tờ tùy thân của quý khách',
				DOB_LABEL: 'Ngày sinh',
				COUNTRY_LABEL: 'Quốc gia đang cư trú',
				COUNTRY_PLACEHOLDER: 'Vui lòng chọn quốc gia nơi quý khách đang cư trú',
				CITY_LABEL: 'Thành phố',
				CITY_PLACEHOLDER: 'Vui lòng nhập thành phố nơi quý khách đang cư trú',
				ADDRESS_LABEL: 'Địa chỉ',
				ADDRESS_PLACEHOLDER: 'Vui lòng nhập địa chỉ nơi quý khách đang cư trú',
				POSTAL_CODE_LABEL: 'Mã bưu điện',
				POSTAL_CODE_PLACEHOLDER: 'Vui lòng nhập mã bưu điện',
				PHONE_CODE_LABEL: 'Quốc Gia',
				PHONE_CODE_PLACEHOLDER:
					'Vui lòng chọn quốc gia nơi số điện thoại của bạn được hòa mạng',
				PHONE_CODE_DISPLAY: '({0}) {1}', // 0 -> (+21)  1 -> South Korea
				PHONE_NUMBER_LABEL: 'Số điện thoại',
				PHONE_NUMBER_PLACEHOLDER: 'Vui lòng nhập số điện thoại của quý khách',
				CONNECTING_LOADING: 'Connecting',
				SMS_SEND: 'Gửi SMS',
				SMS_CODE_LABEL: 'Mã xác nhậnSMS',
				SMS_CODE_PLACEHOLDER: 'Nhập mã xác nhận SMS',
			},
			INFORMATION: {
				TEXT:
					'QUAN TRỌNG: Nhập chính xác tên được viết trong giấy tờ tùy thân của quý khách vào mỗi mục tương ứng (đầy đủ họ, tên đệm và tên. Nếu muốn tạo tài khoản cho doanh nghiệp, hãy liên hệ với đội hỗ trợ khách hàng.',
				TITLE_PERSONAL_INFORMATION: 'Thông tin cá nhân',
				TITLE_PHONE: 'Số điện thoại',
				PHONE_VERIFICATION_TXT:
					'Cung cấp thông tin không hợp lệ có thể gây ảnh hưởng lớn tới công tác xử lý trong trường hợp ngăn chặn những giao dịch không mong muốn trên tài khoản của quý khách.',
				PHONE_VERIFICATION_TXT_1:
					'Xác thực số điện thoại để nhận nhận thông báo cập nhật trực tiếp về các giao dịch nạp tiền và rút tiền.',
				PHONE_VERIFICATION_TXT_2:
					'Cung cấp số điện thoại LAN của quý khách và thực hiện các thủ tục xác thực bổ sung (không bắt buộc).',
			},
		},
		ID_DOCUMENTS_FORM: {
			VALIDATIONS: {
				ID_TYPE: 'Hãy chọn một loại giấy tờ tùy thân',
				ID_NUMBER: 'Vui lòng nhập số giấy tờ tùy thân',
				ISSUED_DATE: 'Vui lòng nhập ngày cấp',
				EXPIRATION_DATE: 'Vui lòng nhập ngày hết hạn',
				FRONT: 'Vui lòng tải lên bản scan hộ chiếu của quý khách.',
				PROOF_OF_RESIDENCY:
					'Vui lòng tải lên hồ sơ chứng minh nơi cư trú hiện tại của quý khách',
				SELFIE_PHOTO_ID:
					'Vui lòng tải lên ảnh chụp chân dung ở tư thế đang cầm hộ chiếu và giấy ghi chú.',
			},
			FORM_FIELDS: {
				TYPE_LABEL: 'Loại giấy tờ tùy thân',
				TYPE_PLACEHOLDER: 'Vui lòng chọn loại giấy tờ tùy thân',
				TYPE_OPTIONS: {
					ID: 'Chứng minh thư nhân dân',
					PASSPORT: 'Hộ chiếu',
				},
				ID_NUMBER_LABEL: 'Số hộ chiếu',
				ID_NUMBER_PLACEHOLDER: 'Vui lòng nhập số hộ chiếu',
				ID_PASSPORT_NUMBER_LABEL: 'Số hộ chiếu',
				ID_PASSPORT_NUMBER_PLACEHOLDER: 'Vui lòng nhập số hộ chiếu',
				ISSUED_DATE_LABEL: 'Ngày cấp',
				EXPIRATION_DATE_LABEL: 'Ngày hết hạn',
				FRONT_LABEL: 'Hộ chiếu',
				FRONT_PLACEHOLDER: 'Thêm bản sao hộ chiếu',
				BACK_LABEL: 'Mặt sau hộ chiếu',
				BACK_PLACEHOLDER: 'Thêm bản sao mặt sau hộ chiếu của quý khách',
				PASSPORT_LABEL: 'Hộ chiếu',
				PASSPORT_PLACEHOLDER: 'Thêm bản sao hộ chiếu',
				POR_LABEL: 'Hồ sơ nơi cư trú',
				POR_PLACEHOLDER: 'Thêm hồ sơ chứng minh nơi cư trú',
				SELFIE_PHOTO_ID_LABEL:
					'Ảnh chân dung chụp cùng hộ chiếu và giấy ghi chú',
				SELFIE_PHOTO_ID_PLACEHOLDER:
					'Thêm ảnh chân dùng chụp cùng hộ chiếu và giấy ghi chú',
			},
			INFORMATION: {
				IDENTITY_DOCUMENT: 'Identity Document',
				PROOF_OF_RESIDENCY: 'Hồ sơ nơi cư trú',
				ID_SECTION: {
					TITLE:
						'Vui lòng đảm bảo rằng hồ sơ của quý khách đáp ứng các hạng mục sau:',
					LIST_ITEM_1:
						'CHẤT LƯỢNG CAO (ảnh màu, độ phân giải 300dpi hoặc cao hơn).',
					LIST_ITEM_2: 'RÕ NÉT (watermark được cho phép).',
					LIST_ITEM_3: 'CÒN HIỆU LỰC, thông tin về ngày hết hạn rõ nét.',
					WARNING_1:
						'Chỉ hộ chiếu còn hiệu lực mới được chấp nhận; tài liệu dưới dạng ảnh chụp rõ nét hoặc bản scan được chấp nhận:',
					WARNING_2:
						'Hãy chắc chắn rằng quý khách tải lên hồ sơ của chính mình. Trong trường hợp xác nhận là hồ sơ giả mạo, chúng tôi sẽ thực hiện các thủ tục pháp lý và đóng băng tài khoản của quý khách ngay lập tức.',
					WARNING_3: 'Không nộp hộ chiếu làm hồ sơ chứng minh nơi cư trú.',
				},
				POR: {
					SECTION_1_TEXT_1:
						'Để tránh tình trạng bị trì hoãn khi thực hiện thủ tục xác thực, hãy chắc chắn rằng:',
					SECTION_1_TEXT_2:
						'TÊN ĐỊA CHỈ, NGÀY CẤP VÀ NGƯỜI CẤP cần phải rõ nét.',
					SECTION_1_TEXT_3:
						'Hồ sơ chứng minh nơi cư chú KHÔNG ĐƯỢC VƯỢT QUÁ 3 THÁNG KỂ TỪ NGÀY CẤP.',
					SECTION_1_TEXT_4:
						'Quý khách nộp ảnh chụp màu hoặc bản scan CHẤT LƯỢNG CAO(độ phân giải thấp nhất 300 DPI)',
					SECTION_2_TITLE:
						'HÔ SƠ CHỨNG MINH NƠI CƯ TRÚ ĐƯỢC CHẤP NHẬN BAO GỒM:',
					SECTION_2_LIST_ITEM_1: 'A bank account statement.',
					SECTION_2_LIST_ITEM_2:
						'Hóa đơn thanh toán chi phí dịch vụ(điện, nước, internet, vv.).',
					SECTION_2_LIST_ITEM_3:
						'Giấy tờ do nhà nước cấp (hóa đơn thuế, bản sao chứng minh thư nhân dân, vv.).',
					WARNING:
						'Chúng tôi không chấp địa chỉ trên giấy tờ tùy hận được nộp là cơ sở chứng minh nơi cư trú.',
				},
				SELFIE: {
					TITLE: 'Ảnh chân dùng chụp cùng hộ chiếu và giấy ghi chú',
					INFO_TEXT:
						'Vui lòng cung cấp ảnh chụp ở tư thế đang cầm hộ chiếu và giấy ghi chú được viết: địa chỉ sàn giao dịch, ngày tháng và chữ ký. Hãy chắc chắn rằng mặt của quý khách xuất hiện rõ nét và thông tin trên giấy tờ tùy nhân có thể đọc được.',
					REQUIRED: 'Yêu cầu:',
					INSTRUCTION_1: 'Khuôn mặt xuất hiện rõ nét',
					INSTRUCTION_2: 'Có thể đọc được thông tin trên hệ chiếu',
					INSTRUCTION_3: 'Viết tên sàn giao dịch',
					INSTRUCTION_4: 'Viết ngày đăng ký',
					INSTRUCTION_5: 'Ký tên của quý khách',
					WARNING:
						'Ảnh chân dung chụp cùng hộ chiếc khác với bản đã tải lên sẽ bị từ chối.',
				},
			},
		},
		BANK_ACCOUNT_FORM: {
			VALIDATIONS: {
				ACCOUNT_OWNER:
					'Vui lòng nhập tên và họ được đăng ký trên tài khoản ngân hàng của quý khách.',
				ACCOUNT_NUMBER:
					'Số tài khoản của quý khách không thể vượt quá 50 ký tự.',
				ACCOUNT_NUMBER_MAX_LENGTH:
					'Số tài khoản của quý khách bị giới hạn trong 50 ký tự.',
				CARD_NUMBER: 'Hình thức thẻ ngân hàng không hợp lệ',
			},
			FORM_FIELDS: {
				BANK_NAME_LABEL: 'Tên ngân hàng',
				BANK_NAME_PLACEHOLDER: 'Vui lòng nhập tên của ngân hàng',
				ACCOUNT_NUMBER_LABEL: 'Số tài khoản ngân hàng',
				ACCOUNT_NUMBER_PLACEHOLDER: 'Vui lòng nhập số tài khoản ngân hàng',
				ACCOUNT_OWNER_LABEL: 'Tên chủ tài khoản',
				ACCOUNT_OWNER_PLACEHOLDER: 'Vui lòng nhập tên chủ tài khoản ngân hàng',
				CARD_NUMBER_LABEL: 'Số thẻ ngân hàng',
				CARD_NUMBER_PLACEHOLDER:
					'Vui lòng nhập số thẻ ngân hàng gồm 16 chữ số ở mặt trước của thẻ',
			},
		},
		WARNING: {
			TEXT_1:
				'Quý khách có thể sử dụng các dịch vụ sau nếu xác thực người dùng:',
			LIST_ITEM_1: 'Tăng hạn mức rút tiền',
			LIST_ITEM_2: 'Tăng hạn mức nạp tiền',
			LIST_ITEM_3: 'Chi phí thấp hơn',
		},
	},
	USER_SETTINGS: {
		TITLE_TEXT_1:
			'Thay đổi cài đặt trên tài khoản của quý khách. Từ giao diện cho tới thông báo, tên người dùng và các tùy chọn khác.',
		TITLE_TEXT_2: 'Sau khi lưu, các thay đổi sẽ được áp dụng.',
		TITLE_NOTIFICATION: 'Thông báo',
		TITLE_INTERFACE: 'Giao diện',
		TITLE_LANGUAGE: 'Ngôn ngữ',
		TITLE_CHAT: 'Trò chuyện',
		TITLE_AUDIO_CUE: 'Âm thanh', // new
		TITLE_MANAGE_RISK: 'Quản lý nguy hiểm',
		ORDERBOOK_LEVEL: 'Cấp bậc sổ lệnh (Tối đa 20)',
		SET_TXT: 'CÀI ĐẶT',
		CREATE_ORDER_WARING: 'Tạo cảnh báo đặt hàng',
		RISKY_TRADE_DETECTED: 'Phát hiện giao dịch nguy hiểm',
		RISKY_WARNING_TEXT_1:
			'Giá trị đơn đặt vượt quá số lượng {0} giới hạn mà quý khách cài đặt.',
		RISKY_WARNING_TEXT_2: '(Danh mục {0})',
		RISKY_WARNING_TEXT_3:
			' Vui lòng kiểm tra lại liệu quý khách có thực sự muốn thực hiện giao dịch này.',
		GO_TO_RISK_MANAGMENT: 'CHUYỂN TỚI MỤC QUẢN LÝ NGUY HIỂM',
		CREATE_ORDER_WARING_TEXT:
			'Tạo một khung cảnh báo khi số lượng giao dịch vượt quá danh mục {0} của quý khách.',
		ORDER_PORTFOLIO_LABEL: 'Số phần trăm danh mục:',
		NOTIFICATION_FORM: {
			TRADE_POPUPS: 'Cửa sổ thông báo giao dịch',
			POPUP_ORDER_CONFIRMATION: 'Yêu cầu xác nhận trước khi gửi đơn đặt hàng',
			POPUP_ORDER_COMPLETED:
				'Hiển thị cửa sổ thông báo sau khi đặt hàng thành công.',
			POPUP_ORDER_PARTIALLY_FILLED:
				'Hiển thị cửa sổ thông báo khi đơn đặt hàng được tiến hành từng phần',
		},
		AUDIO_CUE_FORM: {
			// new
			ALL_AUDIO: 'Bật âm thanh cho tất cả',
			PUBLIC_TRADE_AUDIO: 'Khi giao dịch công khai được thực hiện (DONE)',
			ORDERS_PARTIAL_AUDIO:
				'Khi một trong những đơn đặt hàng được tiến hành từng phần (DONE)',
			ORDERS_PLACED_AUDIO: 'Khi một đơn đặt hàng được tạo',
			ORDERS_CANCELED_AUDIO: 'Khi một đơn đặt hàng bị hủy',
			ORDERS_COMPLETED_AUDIO:
				'Khi một trong những đơn đặt hàng hoàn tất thành công',
			CLICK_AMOUNTS_AUDIO: 'Khi nhấn chọn số lượng và giá trong sổ lệnh',
			GET_QUICK_TRADE_AUDIO: 'Khi có một lời nhẳn trong giao dịch nhanh',
			SUCCESS_QUICK_TRADE_AUDIO:
				'Khi có một giao dịch nhanh diễn ra thành công',
			QUICK_TRADE_TIMEOUT_AUDIO: 'Khi hết thời gian giao dịch nhanh',
		},
		RISK_MANAGEMENT: {
			INFO_TEXT:
				'Tạo một khung cảnh báo khi số lượng giao dịch vượt quá tỷ lệ phần trăm được cài đặt trong danh mục',
			INFO_TEXT_1: 'Tổng giá trị tài sản {0}: {1}',
			PORTFOLIO: 'Tỷ lệ phần trăm danh mục',
			VALUE_ASSET: 'Giá trị ước chừng',
			ADJUST: '(ĐIỀU CHỈNH TỶ LỆ)',
			ACTIVATE_RISK_MANAGMENT: 'Bật quản lý nguy hiểm',
			WARNING_POP_UP: 'Cửa sổ cảnh báo',
		},
	},
	TRANSACTION_HISTORY: {
		TITLE: 'Lịch sử',
		TITLE_TRADES: 'Lịch sử giao dịch',
		TITLE_DEPOSITS: 'Lịch sử nạp tiền',
		TITLE_WITHDRAWALS: 'Lịch sử rút tiền',
		TEXT_DOWNLOAD: 'TẢI LỊCH SỬ',
		TRADES: 'Giao dịch',
		DEPOSITS: 'Nạp tiền',
		WITHDRAWALS: 'Rút tiền',
	},
	ACCOUNT_SECURITY: {
		TITLE_TEXT:
			'Điều chỉnh các cài đặt bảo mật cho tài khoản của quý khách. Có thể cài đặt Xác thực 2 yếu tố, mật khẩu, khóa API và các chức năng bảo mật khác.',
		OTP: {
			TITLE: 'Xác thực 2 yếu tố',
			OTP_ENABLED: 'Bật OTP',
			OTP_DISABLED: 'VUI LÒNG BẬT 2FA',
			ENABLED_TEXTS: {
				TEXT_1: 'Yêu cầu OYP khi đăng nhập',
				TEXT_2: 'Yeu cầu OTP khi rút tiền',
			},
			DIALOG: {
				SUCCESS: 'Quý khách đã kích hoạt 2FA thành công',
				REVOKE: 'Quý khách đã hủy OTP thành công',
			},
			CONTENT: {
				TITLE: 'Kích hoạt Xác thực 2 yếu tố',
				MESSAGE_1: 'Quét',
				MESSAGE_2:
					'Quét mã QR bên dưới bằng Google Authenticator hoặc Authy để cài đặt Xác thực 2 yếu tố trên thiết bị của quý khách.',
				MESSAGE_3:
					'Nếu gặp khó khăn khi quét, quý khách có thể nhập thủ công mã bên dưới.',
				MESSAGE_4:
					'Quý khách có thể bảo quản mã này một cách an toàn để thiết lập lại 2FA trong trường hợp thay đổi hoặc bị mất điện thoại.',
				MESSAGE_5: 'Thủ công',
				INPUT: 'Vui lòng nhập mã (OTP) một lần',
				WARNING:
					'Chúng tôi khuyến khích quý khách cài đặt Xác thực 2 yếu tố (2FA). Điều này sẽ giúp nâng cao độ bảo mật cho tài khoản của quý khách.',
				ENABLE: 'Bật Xác thực 2 yếu tố',
				DISABLE: 'Tắt Xác thực 2 yếu Tối',
				SECRET_1: 'Enter yor secret key',
				SECRET_2: 'Please enter your secret key to confirm you wrote it down.',
				SECRET_3:
					'This secret key will help you recover your account if you lost access to your phone.',
				INPUT_1: 'Secret Key',

				TITLE_2: 'Nhập mật khẩu một lần (OTP)',
				MESSAGE_6:
					'Vui lòng nhập mật khẩu một lần bao gồm 6 ký tự xuống phía dưới.',
				INPUT_2: 'Mật khẩu một lần (OTP)',
			},
			FORM: {
				PLACEHOLDER:
					'Vui lòng nhập OTP được cung cấp bởi Google Authenticator.',
				BUTTON: 'Bật 2FA',
			},
		},
		CHANGE_PASSWORD: {
			TITLE: 'Thay đổi mật khẩu',
			ACTIVE: 'KÍCH HOẠT',
			DIALOG: {
				SUCCESS: 'Mật khẩu đã được thay đổi thành công.',
				EMAIL_CONFIRMATION:
					'Một email được gửi cho bạn để cho phép thay đổi mật khẩu.',
			},
			FORM: {
				BUTTON: 'Thay đổi mật khẩu',
				CURRENT_PASSWORD: {
					label: 'Mật khẩu hiện tại',
					placeholder: 'Vui lòng nhập mật khẩu hiện tại',
				},
				NEW_PASSWORD: {
					label: 'Mật khẩu mới',
					placeholder: 'Vui lòng nhập mật khẩu mới',
				},
				NEW_PASSWORD_REPEAT: {
					label: 'Xác nhận mật khẩu mới',
					placeholder: 'Vui lòng nhập lại mật khẩu mới',
				},
			},
		},
		LOGIN: {
			TITLE: 'Lịch sử đăng nhập',
			CONTENT: {
				TITLE: 'Lịch sử đăng nhập',
				MESSAGE:
					'Below is login history list with details IP, country and time details. If you see any suspicious activity you should change your password and contact support',
			},
		},
		FREEZE: {
			TITLE: 'Freeze Account',
			CONTENT: {
				MESSAGE_1:
					'Freezing your account will stop whitdrawals and halts all tradings.',
				WARNING_1:
					'Use only if you fear that your account has been compromised',
				TITLE_1: 'Freeze your Account',
				TITLE_2: 'Account freezing',
				MESSAGE_2:
					'Freezing your account may help guard your account from cyber attacks.',
				MESSAGE_3:
					'The following will occur if you choose to freeze your account:',
				MESSAGE_4: '1. Pending withdrawals will be canceled.',
				MESSAGE_5:
					'2. All tradings will be halted and unfilled orders will be canceled.',
				MESSAGE_6:
					'3. Containing support will be required to reactivate your account.',
				WARNING_2: 'Do you really want to freeze your account?',
			},
		},
	},
	CURRENCY: 'Loại tiền',
	TYPE: 'Type',
	TYPES_VALUES: {
		market: 'market',
		limit: 'limit',
	},
	TYPES: [
		{ value: 'market', label: 'Thị trường' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: 'limit', label: 'CHỈ ĐỊNH' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SIDE: 'Side',
	SIDES_VALUES: {
		buy: 'Mua',
		sell: 'Bán',
	},
	SIDES: [
		{ value: 'buy', label: 'Mua' },
		{ value: 'sell', label: 'Bán' },
	], // DO NOT CHANGE value, ONLY TRANSLATE label
	DEFAULT_TOGGLE_OPTIONS: [
		{ value: true, label: 'Bật' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: false, label: 'Tắt' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SIZE: 'Số lượng',
	PRICE: 'Giá',
	FEE: 'Fee',
	FEES: 'Phí giao dịch',
	LIMIT: 'Limit',
	TIME: 'Thời gian',
	TIMESTAMP: 'Timestamp',
	MORE: 'More',
	VIEW: 'View',
	STATUS: 'Trạng thái',
	AMOUNT: 'Số lượng',
	COMPLETE: 'Complete',
	PENDING: 'Pending',
	REJECTED: 'Rejected',
	ORDERBOOK: 'SỔ LỆNH',
	CANCEL: 'Cancel',
	CANCEL_ALL: 'Cancel All',
	GO_TRADE_HISTORY: 'Xem lịch sử giao dịch',
	ORDER_ENTRY: 'NHẬP ĐƠN ĐẶT HÀNG',
	TRADE_HISTORY: 'Lịch sử',
	CHART: 'BẢNG XẾP HẠNG GIÁ',
	ORDERS: 'Đơn đặt hàng đang chờ',
	TRADES: 'Lịch sử giao dịch của tôi',
	RECENT_TRADES: 'Giao dịch gần đây của tôi', // ToDo
	PUBLIC_SALES: 'BÁN CÔNG KHAI', // ToDo
	REMAINING: 'Remaining',
	FULLFILLED: '{0} % Filled',
	FILLED: 'Filled', // new
	LOWEST_PRICE: 'Lowest Price ({0})', // new
	PHASE: 'Phase', // new
	INCOMING: 'Incoming', // new
	PRICE_CURRENCY: 'GIÁ',
	AMOUNT_SYMBOL: 'SỐ LƯỢNG',
	MARKET_PRICE: 'Giá thị trường',
	ORDER_PRICE: 'Giá chỉ định',
	TOTAL_ORDER: 'Tổng',
	NO_DATA: 'KHÔNG CÓ DỮ LIỆU',
	LOADING: 'Loading',
	CHART_TEXTS: {
		d: 'Date',
		o: 'Open',
		h: 'High',
		l: 'Low',
		c: 'Close',
		v: 'Khối lượng',
	},
	QUICK_TRADE: 'Giao dịch nhanh',
	PRO_TRADE: 'Giao dịch chuyên nghiệp',
	ADMIN_DASH: 'Trang người quản lý',
	WALLET_TITLE: 'Ví',
	TRADING_MODE_TITLE: 'Trạng thái giao dịch',
	TRADING_TITLE: 'Giao dịch',
	LOGOUT: 'Đăng xuất',
	WITHDRAWALS_MIN_VALUE_ERROR:
		'Số lượng quá nhỏ để tiến hành thủ tục rút tiền. Vui lòng thử lại với số lượng lớn hơn.',
	WITHDRAWALS_MAX_VALUE_ERROR:
		'Số lượng quá lớn để tiến hành thủ tục rút tiền. Vui lòng thử lại với số lượng nhỏ hơn.',
	WITHDRAWALS_LOWER_BALANCE:
		'You don’t have enough {0} in your balance to send that transaction',
	WITHDRAWALS_FEE_TOO_LARGE:
		'The fee is more than {0}% of your total transaction',
	WITHDRAWALS_BTC_INVALID_ADDRESS:
		'Địa chỉ Bitcoin không hợp lệ. Vui lòng kiểm tra và nhập lại.',
	WITHDRAWALS_ETH_INVALID_ADDRESS:
		'Địa chỉ Ethereum không hợp lệ. Vui lòng kiểm tra và nhập lạiTĐịa chỉ Bitcoin không hợp lệ. Vui lòng kiểm tra và nhập lại.',
	WITHDRAWALS_BUTTON_TEXT: 'Kiểm tra chi tiết rút tiền',
	WITHDRAWALS_FORM_ADDRESS_LABEL: 'Địa chỉ nhận',
	WITHDRAWALS_FORM_ADDRESS_PLACEHOLDER: 'Nhập địa chỉ',
	WITHDRAWALS_FORM_DESTINATION_TAG_LABEL: 'Destination tag (optional)', // new
	WITHDRAWALS_FORM_MEMO_LABEL: 'Memo (optional)', // new
	WITHDRAWALS_FORM_DESTINATION_TAG_PLACEHOLDER: 'Type the destination tag', // new
	WITHDRAWALS_FORM_MEMO_PLACEHOLDER: 'Type the transaction memo', // new
	WITHDRAWALS_FORM_AMOUNT_LABEL: 'Số lượng {0} muốn rút',
	WITHDRAWALS_FORM_AMOUNT_PLACEHOLDER:
		'Type the amount of {0} you wish to withdraw',
	WITHDRAWALS_FORM_FEE_COMMON_LABEL: 'Phí giao dịch',
	WITHDRAWALS_FORM_FEE_FIAT_LABEL: 'Bank withdrawal fee',
	WITHDRAWALS_FORM_FEE_PLACEHOLDER:
		'Type the amount of {0} you wish to use in the fee of the transaction',
	WITHDRAWALS_FORM_FEE_OPTIMAL_VALUE: 'Optimal fee: {0} {1}', // TODO {0} -> amount {1} -> currency name
	DEPOSITS_FORM_AMOUNT_LABEL: '{0} amount to deposit',
	DEPOSITS_FORM_AMOUNT_PLACEHOLDER:
		'Type the amount of {0} you wish to withdraw',
	DEPOSITS_BUTTON_TEXT: 'review deposit',
	DEPOSIT_PROCEED_PAYMENT: 'Pay',
	DEPOSIT_BANK_REFERENCE:
		'Add this "{0}" code to the bank transation to identify the deposit',
	DEPOSIT_METHOD: 'Phương thức thanh toán {0}',
	DEPOSIT_METHOD_DIRECT_PAYMENT: 'Thẻ tín dụng',
	DEPOSIT_METHOD_DIRECT_PAYMENT_MESSAGE_1:
		'Tiến hành thanh toán bằng thẻ tín dụng.',
	DEPOSIT_METHOD_DIRECT_PAYMENT_MESSAGE_2:
		'Quý khách cần rời khỏi nền tảng để thực hiện thanh toán.',
	DEPOSIT_VERIFICATION_WAITING_TITLE: 'Đang xác nhận thanh toán',
	DEPOSIT_VERIFICATION_WAITING_MESSAGE:
		'Vui lòng không đóng ứng dụng này khi giao dịch đang được xác nhận.',
	DEPOSIT_VERIFICATION_WARNING_MESSAGE:
		'Hãy liên hệ với chúng tôi nếu gặp vấn đề trong quá trình xác nhận.',
	DEPOSIT_VERIFICATION_WARNING_INFORMATION:
		'This is the ID of the operation: "{0}", please provide us this ID to help you.',
	DEPOSIT_VERIFICATION_SUCCESS: 'Đã xác nhận thanh toán',
	DEPOSIT_VERIFICATION_ERROR:
		'Đã xảy ra lỗi trong quá trình xác nhận yêu cầu nạp tiền.',
	DEPOSIT_VERIFICATION_ERROR_VERIFIED: 'Yêu cầu nạp tiền đã được xác nhận.',
	DEPOSIT_VERIFICATION_ERROR_STATUS: 'Trạng thái lỗi',
	DEPOSIT_VERIFICATION_ERROR_USER_MATCH:
		'Thẻ mà quý khách sử dụng để thanh toán không trùng khớp với thẻ đã được đăng ký. Vì vậy, yêu cầu nạp tiền của quý khách bị từ chối và thủ tục hoàn trả sẽ được thực hiện trong vòng 1 giờ.',
	QUOTE_MESSAGE: 'You are going to {0} {1} {2} for {3} {4}',
	QUOTE_BUTTON: 'Accept',
	QUOTE_REVIEW: 'Review',
	QUOTE_COUNTDOWN_MESSAGE: 'You have {0} seconds to perform the trade',
	QUOTE_EXPIRED_TOKEN: 'The quote token has expired.',
	QUOTE_SUCCESS_REVIEW_TITLE: 'Quick Trade',
	QUOTE_SUCCESS_REVIEW_MESSAGE: 'You have successfully {0} {1} {2}', // you have successfully buy 1 btc from
	COUNTDOWN_ERROR_MESSAGE: 'Countdown is finished',
	WITHDRAW_PAGE: {
		BANK_TO_WITHDRAW: 'Bank to Withdraw to',
		MESSAGE_ABOUT_SEND: 'You are about to send',
		MESSAGE_BTC_WARNING:
			'Please ensure the accuracy of this address since {0} transfers are irreversible',
		MESSAGE_ABOUT_WITHDRAW: 'You are about to transfer to your bank account',
		MESSAGE_FEE: 'Transactions fee of {0} ({1}) included',
		MESSAGE_FEE_BASE: 'Transactions fee of {0} included',
		BASE_MESSAGE_1:
			'You can only withdraw to a bank account in a name that matches the name registered with your account.',
		BASE_MESSAGE_2: 'Withdrawal min amount',
		BASE_MESSAGE_3: 'Daily withdrawal max amount',
		BASE_INCREASE_LIMIT: 'Increase your daily limit',
		CONFIRM_VIA_EMAIL: 'Confirm via Email',
		CONFIRM_VIA_EMAIL_1: 'We have sent you a confirmation withdrawal email.',
		CONFIRM_VIA_EMAIL_2:
			'In order to complete the withdrawal process please confirm',
		CONFIRM_VIA_EMAIL_3: 'the withdrawal via your email within 5 minutes.',
		WITHDRAW_CONFIRM_SUCCESS_1:
			'Your withdrawal request is confirmed. It will be processed shortly.',
		WITHDRAW_CONFIRM_SUCCESS_2:
			'In order to view your withdrawal status please visit your withdrawal history page.',
		GO_WITHDRAWAL_HISTORY: 'Go To Withdrawal History',
	},
	WALLET_BUTTON_BASE_DEPOSIT: 'Nạp tiền',
	WALLET_BUTTON_BASE_WITHDRAW: 'Rút tiền',
	WALLET_BUTTON_CRYPTOCURRENCY_DEPOSIT: 'Nhận',
	WALLET_BUTTON_CRYPTOCURRENCY_WITHDRAW: 'Gửi',
	AVAILABLE_TEXT: 'Available',
	AVAILABLE_BALANCE_TEXT: 'Số dư {0} khả dụng : {1} {2}', // Available Bitcoin Balance: 2.6 BTC
	BALANCE_TEXT: 'Số dư',
	CURRENCY_BALANCE_TEXT: '{0} Balance',
	WALLET_TABLE_AMOUNT_IN: `Amount in {0}`,
	WALLET_TABLE_TOTAL: 'Tổng',
	WALLET_ALL_ASSETS: 'Tất cả tài sản',
	HIDE_TEXT: 'Hide',
	PAGINATOR_FORMAT: '{0} / {1}',
	ORDERBOOK_SELLERS: 'Người bán',
	ORDERBOOK_BUYERS: 'Người Mua',
	ORDERBOOK_SPREAD: 'Chênh lệch {0}', // 0 -> 660,000 T
	ORDERBOOK_SPREAD_PRICE: '{0} {1}', //// 0-> amount  1 -> symbol  600,000 T
	CALCULATE_MAX: 'Tối đa',
	DATEFIELD_TOOGLE_DATE_GR: 'Gregorian calendar',
	VERIFICATION_WARNING_TITLE: 'Verification you bank details',
	VERIFICATION_WARNING_MESSAGE:
		'Before you withdraw, you need to verify your bank details.',
	ORDER_SPENT: 'Spent',
	ORDER_RECEIVED: 'Received',
	ORDER_SOLD: 'Sold',
	ORDER_BOUGHT: 'Bought',
	ORDER_AVERAGE_PRICE: 'Average price',
	ORDER_TITLE_CREATED: 'Successfully created a limit {0}', // 0 -> buy / sell
	ORDER_TITLE_FULLY_FILLED: '{0} order successfully filled', // 0 -> buy / sell
	ORDER_TITLE_PARTIALLY_FILLED: '{0} order partially filled', // 0 -> buy / sell
	ORDER_TITLE_TRADE_COMPLETE: '{0} {1} order was successful', // 0 -> buy / sell
	LOGOUT_TITLE: 'You have been logged out',
	LOGOUT_ERROR_TOKEN_EXPIRED: 'Token is expired',
	LOGOUT_ERROR_LOGIN_AGAIN: 'Login again', // ip doesnt match
	LOGOUT_ERROR_INVALID_TOKEN: 'Invalid token',
	LOGOUT_ERROR_INACTIVE:
		'You have been logged out because you have been inactive',
	ORDER_ENTRY_BUTTON: '{0} {1}', // 0 -> buy/sell 1 -> btc/..
	QUICK_TRADE_OUT_OF_LIMITS: 'Order size is out of the limits',
	QUICK_TRADE_TOKEN_USED: 'Token has been used',
	QUICK_TRADE_QUOTE_EXPIRED: 'Quote has expired',
	QUICK_TRADE_QUOTE_INVALID: 'Invalid quote',
	QUICK_TRADE_QUOTE_CALCULATING_ERROR: 'Error calculating the quote',
	QUICK_TRADE_ORDER_CAN_NOT_BE_FILLED:
		'The order with the current size can not be filled',
	QUICK_TRADE_ORDER_NOT_FILLED: 'Order is not filled',
	QUICK_TRADE_NO_BALANCE: 'Insufficient balance to perform the order',
	YES: 'Yes',
	NO: 'No',
	NEXT: 'Next',
	SKIP_FOR_NOW: 'Skip for now',
	SUBMIT: 'Gửi',
	RESUBMIT: 'Gửi lại',
	VERIFICATION_NOTIFICATION_SKIP_TITLE: 'Missing Documents!',
	VERIFICATION_NOTIFICATION_SKIP_TEXT:
		'To get full access to withdrawal and deposit functions you must submit your identity documents in your account page.',
	VERIFICATION_NOTIFICATION_SUCCESS_TITLE: 'Success!',
	VERIFICATION_NOTIFICATION_SUCCESS_TEXT:
		'You will receive an email notification when your information has been processed. Processing can typically take 1-3 days.',
	VERIFICATION_NOTIFICATION_BUTTON: 'PROCEED TO EXCHANGE',
	ERROR_USER_ALREADY_VERIFIED: 'User already verified',
	ERROR_INVALID_CARD_USER: 'Bank or card information provided is incorrect',
	ERROR_INVALID_CARD_NUMBER: 'Invalid Card number',
	ERROR_LOGIN_USER_NOT_VERIFIED: 'User is not verified',
	ERROR_LOGIN_USER_NOT_ACTIVATED: 'User is not activated',
	ERROR_LOGIN_INVALID_CREDENTIALS: 'Credentials incorrect',
	SMS_SENT_TO: 'SMS sent to {0}', // TODO check msg
	SMS_ERROR_SENT_TO:
		'Error sending the SMS to {0}. Please refresh the page and try again.', // TODO check msg
	WITHDRAW_NOTIFICATION_TRANSACTION_ID: 'Transaction ID:', // TODO check msg
	CHECK_ORDER: 'Check and confirm your order',
	CHECK_ORDER_TYPE: '{0} {1}', // 0 -> maker/limit  1 -> sell/buy
	CONFIRM_TEXT: 'Confirm',
	GOTO_XHT_MARKET: 'Go to XHT market', // new
	INVALID_CAPTCHA: 'Invalid captcha',
	NO_FEE: 'N/A',
	SETTINGS_LANGUAGE_LABEL: 'Cài đặt ngôn ngữ (Bao gồm email)',
	SETTINGS_LANGUAGE_OPTIONS: LANGUAGES,
	SETTINGS_ORDERPOPUP_LABEL: 'Display order confirmation popup',
	SETTINGS_ORDERPOPUP_OPTIONS: [
		{ value: false, label: 'NO' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: true, label: 'YES' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SETTINGS_THEME_LABEL: 'Chủ đề giao diện người dùng', // TODO set right labels // ToDo
	SETTINGS_THEME_OPTIONS: [
		{ value: 'white', label: 'White' }, // DO NOT CHANGE value, ONLY TRANSLATE label
		{ value: 'dark', label: 'Dark' }, // DO NOT CHANGE value, ONLY TRANSLATE label
	],
	SETTING_BUTTON: 'Lưu',
	STRING_WITH_PARENTHESIS: '{0} ({1})',
	VERIFICATION_NO_WITHDRAW_TITLE: 'Vô hiệu hóa rút tiền',
	VERIFICATION_NO_WITHDRAW_MESSAGE:
		'Chức năng rút tiền trên tài khoản của quý khách đã bị vô hiệu hóa.',
	UP_TO_MARKET: 'Tuỳ theo thị trường',
	VIEW_MY_FEES: 'Xem phí giao dịch của tôi', // new
	DEVELOPER_SECTION: {
		TITLE: 'Khóa API',
		INFORMATION_TEXT:
			'API mang tới các chức năng ví dụ như: thông tin số dư ví, quản lý đơn đặt hàng Mua/Bán, yêu cầu rút tiền cũng như các dữ liệu thị trường như các giao dịch gần đây, sổ lệnh và ticker.',
		ERROR_INACTIVE_OTP:
			'Để tạo một khóa API, quý khách cần bật Xác thực 2 yếu tố.',
		ENABLE_2FA: 'Bật 2FA',
		WARNING_TEXT: 'Không chia sẻ khóa API của quý khách với bất kỳ ai.',
		GENERATE_KEY: 'Tạo khóa API',
		ACTIVE: 'Kích hoạt',
		INACTIVE: 'Vô hiệu hóa',
		INVALID_LEVEL:
			'Quý khách cần nâng cấp độ xác thực của tài khoản để sử dụng chức năng này.', // TODO
	},
	DEVELOPERS_TOKENS_POPUP: {
		GENERATE_TITLE: 'Tạo khóa API',
		GENERATE_TEXT:
			'Vui lòng đặt tên cho khóa API của quý khách và lưu giữu nó một cách an toàn sau khi tạo. Quý khách sẽ không thể kiểm tra lại nó.',
		GENERATE: 'Tạo',
		DELETE_TITLE: 'Xóa khóa API',
		DELETE_TEXT:
			'Quý khách không thể hủy lệnh xóa này mặc dù có thể tạo một API mới bất kỳ lúc nào. Quý khách có chắc chắn muốn xóa khóa API?',
		DELETE: 'DELETE',
		FORM_NAME_LABEL: 'Tên',
		FORM_LABLE_PLACEHOLDER: 'Tên khóa API',
		API_KEY_LABEL: 'Khóa API',
		SECRET_KEY_LABEL: 'Khóa BÍ MẬT',
		CREATED_TITLE: 'Sao chép khóa API',
		CREATED_TEXT_1:
			'Vui lòng sao chép khóa API của mình bởi quý khách không thể kiểm tra lại trong tương lai.',
		CREATED_TEXT_2: 'Bảo quản khóa của mình một cách bí mật.',
	},
	DEVELOPERS_TOKENS_TABLE: {
		NAME: 'Tên',
		API_KEY: 'Khóa API',
		SECRET: 'Bí mật',
		CREATED: 'Ngày tạo',
		REVOKE: 'Hủy',
		REVOKED: 'Đã hủy',
		REVOKE_TOOLTIP: 'Quý khách cần bật @FA để hủy token.', // TODO
	},
	CHAT: {
		CHAT_TEXT: 'Trò chyện',
		MARKET_CHAT: 'Market Chat',
		CHAT_UNREAD: '{0} ({1})', // 0 -> CHAT_TEXT, 1 -> number
		READ_MORE: 'Đọc thêm',
		SHOW_IMAGE: 'Xem hình ảnh',
		HIDE_IMAGE: 'Ẩn hình ảnh',
		CHAT_MESSAGE_BOX_PLACEHOLDER: 'Tin nhắn',
		SIGN_UP_CHAT: 'Đăng nhập để trò chuyện',
		JOIN_CHAT: 'Đặt tên để trò chuyện',
		TROLLBOX: 'Trollbox ({0})', // new
	},
	INVALID_USERNAME:
		'Tên người dùng cần bao gồm 3~15 ký tự. Chỉ có chữ cái thường, chữ số và _ được chấp nhận.',
	USERNAME_TAKEN: 'Tên này đã tồn tại. Vui lòng thử một tên khác.',
	USERNAME_LABEL: 'Tên người dùng (sử dụng để trò chuyện)',
	USERNAME_PLACEHOLDER: 'Tên người dùng',
	TAB_USERNAME: 'Tên người dùng',
	USERNAME_WARNING:
		'Chỉ có thể thay đổi tên người dùng duy nhất một lần. Vui lòng xác nhận lại tên người dùng của quý khách.',
	USERNAME_CANNOT_BE_CHANGED: 'Không thể thay đổi tên người dùng',
	UPGRADE_LEVEL: 'Nâng cấp bậc tài khoản',
	LEVELS: {
		LABEL_LEVEL: 'Cấp bậc',
		LABEL_LEVEL_1: 'One',
		LABEL_LEVEL_2: 'Two',
		LABEL_LEVEL_3: 'Three',
		LABEL_MAKER_FEE: 'Maker Fee',
		LABEL_TAKER_FEE: 'Taker Fee',
		LABEL_BASE_DEPOSIT: 'Nạp Euro hàng ngày',
		LABEL_BASE_WITHDRAWAL: 'Rút Euro hàng ngày',
		LABEL_BTC_DEPOSIT: 'Nạp Bitcoin hàng ngày',
		LABEL_BTC_WITHDRAWAL: 'Rút Bitcoin hàng ngày',
		LABEL_ETH_DEPOSIT: 'Nạp Ethereum hàng ngày',
		LABEL_ETH_WITHDRAWAL: 'RÚt Ethereum hàng ngày',
		LABEL_PAIR_MAKER_FEE: '{0} Maker Fee',
		LABEL_PAIR_TAKER_FEE: '{0} Taker Fee',
		UNLIMITED: 'Không giới hạn',
		BLOCKED: 'Disabled',
	},
	WALLET_ADDRESS_TITLE: 'Tạo ví {0}',
	WALLET_ADDRESS_GENERATE: 'Tạo',
	WALLET_ADDRESS_MESSAGE:
		'Tạo một địa chỉ ví có nghĩa là quý khách đã tạo một địa chỉ để nạp và rút tiền.',
	WALLET_ADDRESS_ERROR:
		'Xảy ra lỗi khi tạo địa chỉ ví, vui lòng tải lại và thử một lần nữa.',
	DEPOSIT_WITHDRAW: 'Nạp tiền/Rút tiền',
	GENERATE_WALLET: 'Tạo ví',
	TRADE_TAB_CHART: 'Bảng xếp hạng',
	TRADE_TAB_TRADE: 'Giao dịch',
	TRADE_TAB_ORDERS: 'Đơn đặt hàng',
	TRADE_TAB_POSTS: 'Posts', // new
	WALLET_TAB_WALLET: 'Ví',
	WALLET_TAB_TRANSACTIONS: 'Transactions',
	RECEIVE_CURRENCY: 'Nhận {0}',
	SEND_CURRENCY: 'Gửi {0}',
	COPY_ADDRESS: 'Sao chép địa chỉ',
	SUCCESFUL_COPY: 'Đã sao chép thành công!',
	QUICK_TRADE_MODE: 'Trạng thái giao dịch nhanh',
	JUST_NOW: 'just now',
	PAIR: 'Cặp giao dịch',
	ZERO_ASSET: 'Quý khách chưa có tài sản.',
	DEPOSIT_ASSETS: 'Nạp tiền',
	SEARCH_TXT: 'Tìm kiếm',
	SEARCH_ASSETS: 'Tìm tài sản',
	TOTAL_ASSETS_VALUE: 'Tổng giá trị tài sản bằng {0}: {1}',
	SUMMARY: {
		TITLE: 'Khái quát',
		TINY_PINK_SHRIMP_TRADER: 'Tiny Pink Shrimp Trader',
		TINY_PINK_SHRIMP_TRADER_ACCOUNT: 'Tiny Pink Shrimp Trader Account',
		LITTLE_RED_SNAPPER_TRADER: 'Little Red Snapper Trader',
		LITTLE_RED_SNAPPER_TRADER_ACCOUNT: 'Little Red Snapper Trader Account',
		CUNNING_BLUE_KRAKEN_TRADING: 'Cunning Blue Kraken Trading',
		CUNNING_BLUE_KRAKEN_TRADING_ACCOUNT: 'Cunning Blue Kraken Trading Account',
		BLACK_LEVIATHAN_TRADING: 'Black Leviathan Trading',
		BLACK_LEVIATHAN_TRADING_ACCOUNT: 'Black Leviathan Trading Account',
		URGENT_REQUIREMENTS: 'Urgent Requirements',
		TRADING_VOLUME: 'Trading Volume',
		ACCOUNT_ASSETS: 'Account Assets',
		ACCOUNT_DETAILS: 'Account Details',
		SHRIMP_ACCOUNT_TXT_1: 'Your journey begins here!',
		SHRIMP_ACCOUNT_TXT_2:
			'Keep swimming true, you’ll soon stand out from the rest of the shoal',
		SNAPPER_ACCOUNT_TXT_1:
			'Congrats on staying your course through the swell of the market.',
		SNAPPER_ACCOUNT_TXT_2:
			'Forge through and fight the surge for more crypto treasures ahead.',
		KRAKEN_ACCOUNT_TXT_1:
			'Likelier to crack jokes than hulls, this crustacean has weathered his share of storms!',
		LEVIATHAN_ACCOUNT_TXT_1:
			'Beast from the abyss, seeing through altcoins into unfathomable depths, masters of midnight waters and tidal wave.',
		VIEW_FEE_STRUCTURE: 'Xem cấu trúc chi phí và hạn mức',
		UPGRADE_ACCOUNT: 'Nâng cấp tài khoản',
		ACTIVE_2FA_SECURITY: 'Kích hoạt bảo mật 2FA ',
		ACCOUNT_ASSETS_TXT_1: 'Hiển thị tất cả tài sản mà quý khách đang sở hữu.',
		ACCOUNT_ASSETS_TXT_2:
			'Sở hữu lượng tài sản lớn sẽ mang tới cho quý khách cơ hội nâng cấp tài khoản, từ đó có ưu đãi nhận huy hiệu đặc biệt và chi phí giao dịch thấp.',
		TRADING_VOLUME_TXT_1:
			'Lịch sử lượng giao dịch của quý khách được hiển thị trong {0} và được tính toán vào mỗi cuối tháng từ tất cả các cặp giao dịch.',
		TRADING_VOLUME_TXT_2:
			'Hoạt động giao dịch thường xuyên sẽ mang tới cho quý khách cơ hội nâng cấp tài khoản từ đó có ưu đãi nhận huy hiệu đặc biệt và lợi ích khác.',
		ACCOUNT_DETAILS_TXT_1:
			'Loại tài khoản quyết định huy hiệu tài khoản, chi phí giao dịch và hạn mức nạp tiền, rút tiền.',
		ACCOUNT_DETAILS_TXT_2:
			'Tuổi của tài khoản, cấp độ hoạt động và tổng tài sản sẽ quyết định khả năng được nâng cấp của tài khoản.',
		ACCOUNT_DETAILS_TXT_3:
			'Để duy trì cấp bậc tài khoản, quý khách cần giao dịch thường xuyên và duy trì lượng tài sản nhất định.',
		ACCOUNT_DETAILS_TXT_4:
			'Tài khoản có thể bị hạ cấp bậc nếu không duy trì lượng tài sản và hoạt động giao dịch.',
		REQUIREMENTS: 'Điều kiện cần thiểt',
		ONE_REQUIREMENT: 'One Requirement only:', // new
		REQUEST_ACCOUNT_UPGRADE: 'Yêu cầu nâng cấp tài khoản',
		FEES_AND_LIMIT: 'Cấu Trúc Chi Phí và Hạn Mức Tài Khoản Cấp Độ {0}', // new
		FEES_AND_LIMIT_TXT_1:
			'Trở thành một trader tiền điện tử là một khởi đầu mới. Đặt mục tiêu thông minh cùng với ý chí, tốc độ và chấp nhận rủi ro, quý khách sẽ có cơ hội nâng cấp tài khoản của mình.',
		FEES_AND_LIMIT_TXT_2:
			'Mỗi tài khoản có chi phí giao dịch và hạn mức nạp tiền, rút tiền riêng.',
		DEPOSIT_WITHDRAWAL_ALLOWENCE: 'Hạn mức Nạp tiền & Rút tiền',
		TRADING_FEE_STRUCTURE: 'Cấu trúc phí giao dịch',
		WITHDRAWAL: 'Rút tiền',
		DEPOSIT: 'Nạp tiền',
		TAKER: 'Người nhận',
		MAKER: 'Người tạo',
		WEBSITE: 'website',
		VIP_TRADER_ACCOUNT_ELIGIBLITY: 'Tư cách nâng cấp lên tài khoản Trader VIP',
		PRO_TRADER_ACCOUNT_ELIGIBLITY: 'Tư cách nâng cấp lên tài khoản Trader Pro',
		TRADER_ACCOUNT_ELIGIBILITY: 'Tư cách tài khoản cấp bậc {0}',
		NOMINAL_TRADING: 'Giao dịch danh nghĩa',
		NOMINAL_TRADING_WITH_MONTH: 'Giao dịch danh nghĩa {0} vừa qua',
		ACCOUNT_AGE_OF_MONTHS: 'Tài khoản hoạt động {0} tháng',
		TRADING_VOLUME_EQUIVALENT: '{0} {1} Khối lượng giao dịch tương đương',
		LEVEL_OF_ACCOUNT: 'Tài khoản cấp bậc {0}',
		LEVEL_TXT_DEFAULT: 'Thêm miêu tả về cấp bậc của quý khách tại đây.',
		LEVEL_1_TXT:
			'Cuộc hành trình của quý khách bắt đầu tại đây, những trader tiền điện tử! Hãy xác thực thông tin cá nhân để nhận phần thưởng cũng như nâng cao hạn mức Nạp tiền & Rút tiền và giảm phí giao dịch.', // new
		LEVEL_2_TXT:
			'Giao dịch với khối lượng trên $3,000 USDT một tháng hoặc giữ số dư ở mức trên 5,000 XHT và nhận ưu đãi phí giao dịch thấp hơn.', // new
		LEVEL_3_TXT:
			'Đây là nơi mọi thứ trở thành hiện thực! Hãy tận hưởng ưu đãi phí giao dịch thấp và hạn mức Nạp tiền & Rút tiền cao. Để nâng cấp lên cấp bậc 3, quý khách cần hoàn tất thủ tục xác thực.', // new
		LEVEL_4_TXT:
			'Giao dịch với khối lượng trên $10,000 USDT một tháng hoặc giữ số dư ở mức trên 10,000 XHT và nhận ưu đãi phí giao dịch thấp hơn nữa.', // new
		LEVEL_5_TXT:
			'Quý khách đã làm được! Tài khoản cấp bậc 5 là tài khoản hiếm có, chỉ dành riêng cho những nhà điều hành sàn giao dịch, người dùng Vault hoặc HollaEx Affiliate Program (HAP). Hãy tận hưởng hạn mức cao và ưu đãi miễn phí phí người tạo.', // new
		LEVEL_6_TXT:
			'Giao dịch với khối lượng trên $300,000 USDT một tháng hoặc giữ số dư ở mức trên 100,000 XHT và nhận ưu đãi phí giao dịch thấp hơn nữa. Số lượng rút tiền đã được gia tăng.', // new
		LEVEL_7_TXT:
			'Giao dịch với khối lượng trên $500,000 USDT một tháng hoặc giữ số dư ở mức trên 300,000 XHT và nhận ưu đãi phí giao dịch thấp hơn nữa. Số lượng rút tiền đã được gia tăng.', // new
		LEVEL_8_TXT:
			'Giao dịch với khối lượng trên $600,000 USDT một tháng hoặc giữ số dư ở mức trên 400,000 XHT và nhận ưu đãi phí giao dịch thấp hơn nữa.', // new
		LEVEL_9_TXT:
			'Giao dịch với khối lượng trên $2,000,000 USDT một tháng hoặc giữ số dư ở mức trên 1,000,000 XHT và nhận ưu đãi phí giao dịch thấp hơn nữa.', // new
		LEVEL_10_TXT:
			'Tài khoản trader cá voi giúp quý khách nhận thêm lợi ích từ việc tạo lập thị trường. Để đạt được tài khoản đặc biệt này, mong quý khách vui lòng liên hệ với chúng tôi.', // new
		CURRENT_TXT: 'Hiện tại',
		TRADER_ACCOUNT_XHT_TEXT:
			'Tài khoản của quý khách đang trong thời gian mở bán trước của XHT, điều đó có nghĩa là quý khách có thể nhận được XHT với $0.10 cho mỗi XHT. Tất cả các khoản nạp tiền đều sẽ được chuyển đổi thành XHT sau khi hoàn tất.',
		TRADER_ACCOUNT_TITLE: 'Tài khoản - Thời gian mở bán trước', // new
		HAP_ACCOUNT: 'Tài khoản HAP', // new
		HAP_ACCOUNT_TXT:
			'Tài khoản của quý khách là một tài khoản chương trình tiếp thị liên kết HollaEx đã được xác thực. Giờ đây, quý khách có thể hưởng 10% tiền thưởng cho mỗi người mà quý khách mời mua XHT.', // new
		EMAIL_VERIFICATION: 'Xác minh địa chỉ email', // new
		DOCUMENTS: 'Hồ sơ', // new
		HAP_TEXT: 'Chương trình tiếp thị liên kết HollaEx (HAP) {0}', // new
		LOCK_AN_EXCHANGE: 'Khóa sàn giao dịch {0}', // new
		WALLET_SUBSCRIPTION_USERS: 'Người dùng đăng ký Vault {0}', // new
		TRADE_OVER_XHT: 'Giao dịch có giá trị trên {0} USDT', // new
		TRADE_OVER_BTC: 'Giao dịch có giá trị trên {0} BTC', // new
		XHT_IN_WALLET: '{0} XHT trong ví', // new
		REWARDS_BONUS: 'Phần thưởng và Hoa hồng', // new
		COMPLETE_TASK_DESC:
			'Hoàn thành nhiệm vụ và nhận phần thưởng trị giá hơn $10,000.', // new
		TASKS: 'Nhiệm vụ', // new
		MAKE_FIRST_DEPOSIT: 'Thực hiện lệnh nạp tiền đầu tiên và nhận 1 XHT', // new
		BUY_FIRST_XHT:
			'Thực hiện giao dịch mua XHT đầu tiên và nhận phần thưởng tương ứng 5 XHT', // new
		COMPLETE_ACC_VERIFICATION:
			'Hoàn tất thủ tục xác thực tài khoản và nhận phần thưởng tương ứng 20 XHT', // new
		INVITE_USER:
			'Mời những người dùng khác và nhận hoa hồng từ các giao dịch của họ', // new
		JOIN_HAP:
			'Tham gia HAP và thu về 10% cho mỗi HollaEx Kit mà quý khách bán được', // new
		EARN_RUNNING_EXCHANGE:
			'Nhận nguồn thu nhập thụ động bằng cách điều hành sàn giao dịch của riêng mình', // new
		XHT_WAVE_AUCTION: 'Dữ liệu XHT Wave Auction', // new
		XHT_WAVE_DESC_1:
			'Sự phân bổ HollaEx token (XHT) được thực hiện thông qua Wave Auction.', // new
		XHT_WAVE_DESC_2:
			'Wave Auction bán một số lượng XHT ngẫu nhiên ở những thời điểm ngẫu nhiên cho người ra giá cao nhất trong sổ lệnh.', // new
		XHT_WAVE_DESC_3:
			'Dữ liệu trong lịch sử của Wave Auction được hiển thị phía dưới.', // new
		WAVE_AUCTION_PHASE: 'Giai đoạn Wave Auction {0}', // new
		LEARN_MORE_WAVE_AUCTION: 'Tìm hiểu thêm Wave Auction', // new
		WAVE_NUMBER: 'Số Wave', // new
		DISCOUNT: '( Khuyến mại {0}% )', // new
		MY_FEES_LIMITS: 'PHÍ GIAO DỊCH VÀ HẠN MỨC CỦA TÔI', // new
	},
	REFERRAL_LINK: {
		TITLE: 'Mời bạn', // new
		INFO_TEXT:
			'Mời bạn bè của quý khách tham gia bằng cách gửi liên kết này và nhận lợi ích từ sự gia nhập của họ.',
		COPY_FIELD_LABEL: 'Chia sẻ liên kết phía dưới với bạn bè và nhận hoa hồng:', // new
		REFERRED_USER_COUT: 'Quý khách đã giới thiệu được {0} người dùng.', // new
		COPY_LINK_BUTTON: 'SAO CHÉP LIÊN KẾT GIỚI THIỆU', // new
		XHT_TITLE: 'NGƯỜI DÙNG DO TÔI GIỚI THIỆU', // new
		XHT_INFO_TEXT: 'Nhận hoa hồng bằng cách mời bạn bè.', // new
		XHT_INFO_TEXT_1: 'Hoa hồng được chi trả thường kỳ tới ví của quý khách.', // new
		APPLICATION_TXT:
			'Để trở thành người phân phối HollaEx Kit, vui lòng điền đơn đăng ký.', // new
		TOTAL_REFERRAL: 'Total bought from referrals:', // new
		PENDING_REFERRAL: 'Commissions Pending:', // new
		EARN_REFERRAL: 'Commissions Earn:', // new
		XHT_COUNT: '{0} XHT', // new
		APPLY_BUTTON: 'APPLY', // new
	},
	STAKE_TOKEN: {
		TITLE: 'Stake HollaEx Token', // new
		INFO_TXT1:
			'HollaEx token (XHT) cần được thế chấp (stake) để chạy phần mềm sàn giao dịch HollaEx Kit.', // new
		INFO_TXT2:
			'Quý khách có thể thế chấp HollaEx token dưới cùng hình thức và thu về XHT không được bán trong suốt khoảng thời gian Wave Auction.', // new
		INFO_TXT3:
			'Đơn giản chỉ cần truy cập dash.bitholla.com và thế chấp sàn giao dịch của riêng mình ngay hôm nay và thu về XHT miễn phí.', // new
		BUTTON_TXT: 'TÌM HIỂU THÊM', // new
	},
	TERMS_OF_SERVICES: {
		// new
		TITLE: 'Thỏa thuận mua HollaEx',
		SERVICE_AGREEMENT: AGREEMENT,
		PROCEED: 'TIẾN HÀNH',
		AGREE_TERMS_LABEL: 'Tôi đã đọc và đồng ý với Thỏa thuận mua HollaEx Token',
		RISK_INVOLVED_LABEL: 'Tôi hiểu rõ về những rủi ro có thể xảy ra',
		DOWNLOAD_PDF: 'Tải tập tin PDF',
		DEPOSIT_FUNDS: 'Nạp tiền vào ví của quý khách để nhận HollaEx Token (XHT)',
		READ_FAG: 'Đọc FAQ về HollaEx tại đây: {0}',
		READ_DOCUMENTATION: 'Đọc whitepaper của HollaEx tại đây: {0}',
		READ_WAVES: 'Quy tắc của đợt Wave Auction công khai tháng 12 sắp tới {0}', // new
		DOWNLOAD_BUY_XHT:
			'Tải tập tin PDF để quan sát kỹ từng bước của tiến trình tại {0}',
		HOW_TO_BUY: 'Làm thế nào để mua HollaEx Token (XHT)',
		PUBLIC_SALES: 'Wave Auction công khai', // new
		CONTACT_US:
			'Đừng ngần ngại liên hệ với chúng tôi nếu quý khách có bất kỳ thắc mắc hoặc vấn đề nào bằng cách gửi thư tới {0}.',
		VISUAL_STEP: 'Quan sát kỹ từng bước của tiến trình tại {0}', // new
		WARNING_TXT:
			'Chúng tôi sẽ xem xét yêu cầu của quý khách và gửi hướng dẫn chi tiết về cách tiếp cận sàn giao dịch HollaEx tới địa chỉ email của quý khách.', // new
		WARNING_TXT1:
			'Trong lúc đó, quý khách có thể làm quen với mạng lưới của HollaEx thông qua những nguồn hỗ trợ phía dưới.', // new
		XHT_ORDER_TXT_1: 'Quý khách cần đăng nhập để có thể bắt đầu giao dịch', // new
		XHT_ORDER_TXT_2: '', // new
		XHT_ORDER_TXT_3: '{0} hoặc {1}', // new
		XHT_TITLE: 'XHT', //new
		XHT_TRADE_TXT_1: 'Đăng nhập để xem các  giao dịch gần đây của mình', //new
		XHT_TRADE_TXT_2:
			'Quý khách có thể {0} để xem lịch sử những giao dịch gần đây.', //new
		LOGIN_HERE: 'Đăng nhập tại đây',
	},
	WAVES: {
		// new
		TITLE: 'Wave Info',
		NEXT_WAVE: 'Next Wave',
		WAVE_AMOUNT: 'Amount in Wave',
		FLOOR: 'Floor',
		LAST_WAVE: 'Last wave',
	},
	TYPES_OF_POSTS: {
		// new
		TITLE: 'POSTS',
		ANNOUNCEMEN: 'Announcement',
		SYSTEM_UPDATE: 'System Update',
		LAST_WAVE: 'Last Wave',
		ANNOUNCEMENT_TXT: 'Free XHT will be distributed to all wallets that apply',
		SYSTEM_UPDATE_TIME: 'Time: 12:31 PM, December 19th, 2019	',
		SYSTEM_UPDATE_DURATION: '1 hour',
		LAST_WAVE_AMOUNT: '100, 213 XHT',
		LAST_WAVE_REDISTRIBUTED: ' 11, 211',
		LAST_WAVE_TIME: ' 12: 31 PM, December 19th, 2019',
	},
	USER_LEVEL: 'Cấp bậc người dùng', // new
	LIMIT_AMOUNT: 'Khối lượng hạn mức', // new
	FEE_AMOUNT: 'Khối lượng phí giao dịch', // new
	COINS: 'Coin', // new
	PAIRS: 'Cặp', // new
	NOTE_FOR_EDIT_COIN: 'Lưu ý: Để thêm hoặc xóa {0}, vui lòng tham khảo {1}.', // new
	REFER_DOCS_LINK: 'Văn bản', // new
	RESTART_TO_APPLY:
		'Quý khách cần khởi động lại sàn giao dịch để áp dụng những thay đổi này.', // new
	TRIAL_EXCHANGE_MSG:
		'Quý khách đang sử dụng phiên bản thử nghiệm của {0} và nó sẽ hết hạn trong {1} ngày.', // new
	EXPIRY_EXCHANGE_MSG:
		'Sàn giao dịch của quý khách đã mãn hạn. Truy cập dash.bitholla.com để kích hoạt nó một lần nữa.', // new
	EXPIRED_INFO_1: 'Phiên bản thử nghiệm quý khách sử dụng đã mãn hạn.', // new
	EXPIRED_INFO_2:
		'Thế chấp sàn giao dịch của quý khách để kích hoạt nó lại lần nữa.', // new
	EXPIRED_BUTTON_TXT: 'KÍCH HOẠT SÀN GIAO DỊCH', // new
	TRADE_POSTS: {
		// new
		ANNOUNCEMENT: 'Thông báo',
		ANNOUNCEMNT_TXT_3:
			'Thời gian ra mắt công khai và Wave Auction được điều chỉnh thành ngày 01 tháng 01 năm 2020. Chức năng Nạp tiền và Rút tiền tại ví đã đi vào hoạt động.',
		ANNOUNCEMNT_TXT_4:
			'Chúc mừng năm mới, Hollaers. Chúng tôi đang tạo ra bướt ngoặt mới kể từ năm 2020 với việc ra mắt nền tảng giao dịch mở cửa nhất nhờ có sự giúp đỡ của tất cả các bạn.',
		ANNOUNCEMNT_TXT_1:
			'Kiếm XHT thông qua chương trình HAP bằng cách giới thiệu bạn bè tới sàn giao dịch. {0}.',
		DEFAULT_ANNOUNCEMENT:
			'Mục này hiển thị những thông báo công khai trên sàn giao dịch của quý khách!',
		ANNOUNCEMENT_TXT_2: 'XHT miễn phí sẽ được phân bổ cho tất cả các ví {0}.',
		LEARN_MORE: 'Tìm hiểu thêm',
		APPLY_TODAY: 'Đăng ký ngay hôm nay', // new
	},
	OPEN_WALLET: 'Ví mở', // new
	AGO: 'ago', // new
	ALL: 'TẤT CẢ', //new
	VIEW_ALL: 'XEM CHI TIẾT', // new
	MARKET_OPTIONS: [
		{ value: 'List', label: 'Danh sách' }, // new
		{ value: 'Card', label: 'Biểu đồ' }, // new
	],
	MARKETS_TABLE: {
		VIEW_MARKETS: 'XEM THỊ TRƯỜNG ', //new
	},
	ORDER_MODE: 'Chế độ đặt hàng', //new
	REGULAR: 'Thông thường', //new
	STOPS: 'Cắt lỗ', //new
	CLEAR: 'XÓA', //new
	TRIGGER_PRICE: 'Giá vào lệnh', //new
	POST_ONLY_TOOLTIP:
		'Post only là lệnh đặt hàng được thêm vào sổ lệnh nhưng không được thực thi ngay.', // new
	ORDER_ENTRY_ADVANCED: 'Xem thêm', //new
	CUMULATIVE_AMOUNT_SYMBOL: 'TỔNG', //new
	ASSET_TXT: 'Tài sản', //new
	ONE_DAY: '1 ngày', //new
	ONE_WEEK: '1 tuần', //new
	MONTH: '{0} tháng', //new
	START_DATE: 'Từ ngày', //new
	END_DATE: 'Đến ngày', //new
	LIMITS_BLOCK: {
		HEADER_ROW_DESCRIPTION:
			'Hạn mức Nạp Tiền và Rút Tiền trong 24 giờ (Tài Khoản Cấp Độ {0})',
		HEADER_ROW_AMOUNT: 'Hạn mức 24 giờ ({0})',
	},
	ESTIMATED_PRICE: 'Giá ước chừng',
};
